import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import UserRow from "src/components/Layout/UserRow";
import localforage from "localforage";
import { connect } from "react-redux";
import { insert } from "src/pages/admin/settingV3/helpers";
import { useLocation } from "react-router-dom";
import "src/App.css";

const Index = ({ heightHeader }) => {
  const [data, setData] = useState([]);
  const location = useLocation();

   useEffect(() => {
     fetchData();
   }, [location.pathname]);

  const fetchData = async () => {
    const pathname = location.pathname;
    const segments = pathname.split("/");
    const lastSegment = segments.pop();

    let tempDataContent;
    if (lastSegment === "vacancy") tempDataContent = tempDataContent1;
    else if (lastSegment === "product") tempDataContent = tempDataContent2;

    const resTempData = await localforage.getItem("tempData");
    const num = heightHeader?.split("rem")[0];
    tempDataContent.sectProps.pt = num * 3 + "rem";
    tempDataContent.sectProps.pb = num * 2 + "rem";
    const tempData = insert(resTempData, 1, tempDataContent);
    setData(tempData);
  };

  const renderRow = (row) => {
    return <UserRow key={row.id} data={row} />;
  };

  return (
    <Grid
      component="main"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F6F8FD",
      }}
    >
      {data
        .filter((v) => v.visibility)
        .map((row) => {
          return <React.Fragment key={row.id}>{renderRow(row)}</React.Fragment>;
        })}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  heightHeader: state.preview.heightHeader,
});

export default connect(mapStateToProps)(Index);

const tempDataContent1 = {
  id: "bqgUcNVjw",
  type: "row",
  props: {
    maxWidth: "90%",
  },
  children: [
    {
      id: "31ZVfDnAV",
      type: "column",
      props: {},
      children: [
        {
          id: "Wa2MSTlSv",
          type: "element",
          variant: "element21", // table vacancy => shortcut : component in list elements library.js
        },
      ],
      colWidth: 12,
    },
  ],
  sectProps: {},
  visibility: true,
};

const tempDataContent2 = {
  id: "bqgUcNVjtr",
  type: "row",
  props: {
    maxWidth: "95%",
  },
  children: [
    {
      id: "31ZVfDnAV",
      type: "column",
      props: {},
      children: [
        {
          id: "Wa2MSTlSv",
          type: "element",
          variant: "element22", // table vacancy => shortcut : component in list elements library.js
        },
      ],
      colWidth: 12,
    },
  ],
  sectProps: {},
  visibility: true,
};
